$(document).ready(function () {
  const firstVariantWrapper = $('.variant-wrapper.js').first();
  firstVariantWrapper.hide();

  selectDefaultSize();
  resetBundleSelection();
});

document.addEventListener('DOMContentLoaded', () => {
  let variantWrapper = document.querySelector('.variant-wrapper.js');
  const newSelectMetafields = document.querySelector('#new-selector-metafields');
  variantWrapper.insertAdjacentElement('beforebegin', newSelectMetafields);
  
  let dropdownContent = document.querySelector('.dropdown-content');

  function updateRadioButtonSelection(value) {
    document.querySelector('.value-selected-size').textContent = value;

    // Specifically target Height variant radio button
    const sizeRadioButton = document.querySelector(`input[name="Height"][value="${value}"]`);

    if (sizeRadioButton) {
      sizeRadioButton.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      sizeRadioButton.dispatchEvent(changeEvent);
    }
  }

  function resetBundleSelection() {
    const onePackRadioButton = document.querySelector('.variant-wrapper.js input[type="radio"]');
    if (onePackRadioButton) {
      onePackRadioButton.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      onePackRadioButton.dispatchEvent(changeEvent);
    }
  }

  function selectDefaultSize() {
    const firstCustomRadio = document.querySelector('.variant-option input[type="radio"]');
    if (firstCustomRadio) {
      const selectedDiv = firstCustomRadio.closest('.variant-option');
      if (selectedDiv) {
        const activeVariantOption = dropdownContent.querySelector('.variant-option.active');
        if (activeVariantOption) {
          activeVariantOption.classList.remove('active');
        }

        const selectedValue = firstCustomRadio.value;
        updateRadioButtonSelection(selectedValue);

        selectedDiv.classList.add('active');
      }
    }
  }

  dropdownContent.addEventListener('click', (event) => {
    const selectedDiv = event.target.closest('.variant-option');
    if (selectedDiv) {
      const activeVariantOption = dropdownContent.querySelector('.variant-option.active');
      if (activeVariantOption) {
        activeVariantOption.classList.remove('active');
      }

      const selectedRadio = selectedDiv.querySelector('input[type="radio"]');
      if (selectedRadio) {
        const selectedValue = selectedRadio.value;
        updateRadioButtonSelection(selectedValue);
      }

      selectedDiv.classList.add('active');
      dropdownContent.style.display = 'none';
    }
  });
});